import { selector } from './selector';
import * as events from "./events";
import * as transfer from "./transfer";

const PageCustomerProfilePrepaidBalance = (function ($) {

    function initEvents() {
        $(document).on('click', selector.btnViewTransactions, events.viewTransactions);
        $(document).on('click', selector.transferAll, transfer.transferAll);
        $(document).on('submit', selector.transferForm, transfer.submitTransfer);
        $(selector.modalTransfer).on('show.bs.modal', transfer.openTransfer);
    }

    function initialize() {
        initEvents();
    }

    return {
        init: initialize
    }
})(jQuery);

export { PageCustomerProfilePrepaidBalance };
